module.exports = __webpack_public_path__ + "static/media/spend-euro.63fb5cf6.svg";